import React from 'react';
import WorldMap from '../../../components/map-views/WorldMap';

const HomeWorldMap = ({
  countries,
  selectedCountry,
  onCountrySelect,
  controllerRef,
  availableIsos,
  disableMapInteraction = false,
}) => (
  <WorldMap
    countries={countries}
    selectedCountry={selectedCountry}
    onCountrySelect={onCountrySelect}
    controllerRef={controllerRef}
    availableIsos={availableIsos}
    disableMapInteraction={disableMapInteraction}
  />
);

export default React.memo(HomeWorldMap);
